// extracted by mini-css-extract-plugin
module.exports = {"strapi-bg-image":"_2tT8IY"};